/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerAdmissionFlags200ResponseDataInner } from './FindAllScreenerAdmissionFlags200ResponseDataInner';
import {
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON,
} from './FindAllScreenerAdmissionFlags200ResponseDataInner';

/**
 * 
 * @export
 * @interface UpdateScreenerLeadAdmissionFlagRequest
 */
export interface UpdateScreenerLeadAdmissionFlagRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateScreenerLeadAdmissionFlagRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScreenerLeadAdmissionFlagRequest
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScreenerLeadAdmissionFlagRequest
     */
    flag_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateScreenerLeadAdmissionFlagRequest
     */
    is_dismissed?: boolean;
    /**
     * 
     * @type {FindAllScreenerAdmissionFlags200ResponseDataInner}
     * @memberof UpdateScreenerLeadAdmissionFlagRequest
     */
    admission_flag?: FindAllScreenerAdmissionFlags200ResponseDataInner;
}

/**
 * Check if a given object implements the UpdateScreenerLeadAdmissionFlagRequest interface.
 */
export function instanceOfUpdateScreenerLeadAdmissionFlagRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateScreenerLeadAdmissionFlagRequestFromJSON(json: any): UpdateScreenerLeadAdmissionFlagRequest {
    return UpdateScreenerLeadAdmissionFlagRequestFromJSONTyped(json, false);
}

export function UpdateScreenerLeadAdmissionFlagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerLeadAdmissionFlagRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'flag_id': !exists(json, 'flag_id') ? undefined : json['flag_id'],
        'is_dismissed': !exists(json, 'is_dismissed') ? undefined : json['is_dismissed'],
        'admission_flag': !exists(json, 'admission_flag') ? undefined : FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON(json['admission_flag']),
    };
}

export function UpdateScreenerLeadAdmissionFlagRequestToJSON(value?: UpdateScreenerLeadAdmissionFlagRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'flag_id': value.flag_id,
        'is_dismissed': value.is_dismissed,
        'admission_flag': FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(value.admission_flag),
    };
}

